import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoSelectedContextComponentDoqProps = {
  doqType: DoqType;
  i18nLocale: I18nLocale;
};

const NoSelectedContextComponentDoqBase = ({
  doqType,
  i18nLocale,
}: NoSelectedContextComponentDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noSelectedContextComponent.title',
          'Choose a context component'
        )}
        message={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noSelectedContextComponent.message',
          'In order to visualize this workspace, you need to choose a context component in the navigator.'
        )}
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoSelectedContextComponentDoq = connect(
  NoSelectedContextComponentDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
